<ng-container *ngIf="rewards$ | async as rewards">
  <div class="desktop">
    <myclubrewards-rewards-desktop
      [rewards]="rewards"
    ></myclubrewards-rewards-desktop>
  </div>
  <div class="tablet">
    <myclubrewards-rewards-tablet
      [rewards]="rewards"
    ></myclubrewards-rewards-tablet>
  </div>
</ng-container>
